import { render, staticRenderFns } from "./UnsubscribeLayout.vue?vue&type=template&id=56776ec2"
import script from "./UnsubscribeLayout.vue?vue&type=script&lang=js"
export * from "./UnsubscribeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports